<template>
    <div class="button-container">
        <button :style="styleObject" class="save" v-on:click="saveChanges">{{buttonTextC}}</button>
    </div>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    buttonText: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    saveChanges() {
      this.$emit('save');
    },
  },
  mounted() {
    /*    if (this.buttonText.length <= 0) {
          this.buttonText = this.$t('buttons.submit');
        } */
  },
  computed: {
    styleObject() {
      const { cssConfig } = this.$store.getters;
      return {
        '--button-color': 'white',
        '--button-background-color': cssConfig.submitButton,
        '--button-border-color': cssConfig.submitButton,
      };
    },
    buttonTextC() {
      if (this.buttonText) {
        return this.buttonText;
      }
      return this.$t('buttons.submit');
    },
  },
};
</script>

<style lang="scss" scoped>
    button {
        border: none;
        background: none;
        cursor: pointer;
        color: var(--button-border-color);
        font-size: rem(18px);
        font-weight: bold;

        &.cancel, &.save {

            color: var(--button-color);
            font-size: rem(18px);
            font-weight: bold;
            padding: 12px 50px;
            border-radius: 30px;
            transition: 300ms all ease-in;

        }

        &.save {
            background: var(--button-background-color);
            border: 1px solid var(--button-border-color);

            &:hover {
                color: var(--button-border-color);
                background: white !important;
            }
        }
    }

    .validation-error {
        button {
            filter: grayscale(100%) !important;

            &:hover {
                cursor: not-allowed;
                background: var(--button-background-color);
                color: white;
            }
        }

    }
</style>
